export const validateEmail = (() => {
  const re = /\S+@\S+\.\S+/;
  return (text) => re.test(text);
})();
